module.exports = __webpack_public_path__ + "img/bird-3.616a8f9f.png";